import { ThirdPartyCookieRenderer } from './thirdPartyCookieRenderer';

export const loadThirdPartyCookieRenderer = async (): Promise<ThirdPartyCookieRenderer> => {
  const { thirdPartyCookieRenderer } = await import(
    /* webpackChunkName: "3-render-thirdpartycookierenderer" */ './thirdPartyCookieRenderer'
  );

  return thirdPartyCookieRenderer;
};
